export const environment = {
  /**
   * Define a quantidade de linhas a ser exibido na listagem
   */
  LINE_LIMIT: 10,
  /**
   * Placehover dos campos de pesquisa
   */
  SEARCH_INPUT: 'Pesquisar...',
  /**
   * Mensagem da lista caso nao tenha registro
   */
  EMPTY_LIST: 'Nenhum registro encontrado',
  /**
   * URL de acesso a api (avaliefacil-backend).
   * CRA: defina REACT_APP_API_URL no .env — ex.: http://localhost:3333
   */
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3333',

  /**
   * APP Name
   */
  APP_NAME: '@avalie-finder',
};
